var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import log from 'pathfinder/utils/log';
import { callFandomService, callFandomServiceWithBody } from 'pathfinder/utils/api';
var serviceNamePath = 'user-notifications';
export var MarketingNotificationResponseStatus;
(function (MarketingNotificationResponseStatus) {
    MarketingNotificationResponseStatus["SUCCESS"] = "SUCCESS";
    MarketingNotificationResponseStatus["ERROR"] = "ERROR";
})(MarketingNotificationResponseStatus || (MarketingNotificationResponseStatus = {}));
export var getNotifications = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, callFandomService(serviceNamePath)];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                log.debug("Couldn't return notifications data. Response.ok: ".concat(response.ok, " | Response.status: ").concat(response.status));
                return [2 /*return*/];
            case 4: return [3 /*break*/, 6];
            case 5:
                error_1 = _a.sent();
                log.error('Error on get notification API', error_1);
                return [2 /*return*/];
            case 6: return [2 /*return*/];
        }
    });
}); };
export var fetchActiveNotifications = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, callFandomService('user-notifications/notifications/placement/banner')];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
            case 3:
                log.debug("Couldn't return active notifications data. Response.ok: ".concat(response.ok, " | Response.status: ").concat(response.status));
                return [2 /*return*/];
            case 4: return [3 /*break*/, 6];
            case 5:
                error_2 = _a.sent();
                log.error('Error on get active notification API', error_2);
                return [2 /*return*/];
            case 6: return [2 /*return*/];
        }
    });
}); };
export var addNotification = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFandomServiceWithBody(serviceNamePath, __assign({}, body))];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, { status: MarketingNotificationResponseStatus.SUCCESS }];
                }
                else {
                    log.error("The notification wasn't added. Response: ".concat(response));
                    return [2 /*return*/, { status: MarketingNotificationResponseStatus.ERROR }];
                }
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                log.error('Error on post notification API', error_3);
                return [2 /*return*/, { status: MarketingNotificationResponseStatus.ERROR }];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var editNotification = function (body, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFandomServiceWithBody("".concat(serviceNamePath, "/").concat(id), __assign({}, body), { method: 'PUT' })];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, { status: MarketingNotificationResponseStatus.SUCCESS }];
                }
                else {
                    log.debug("The notification wasn't edited. Response: ".concat(response));
                    return [2 /*return*/, { status: MarketingNotificationResponseStatus.ERROR }];
                }
                return [3 /*break*/, 3];
            case 2:
                error_4 = _a.sent();
                log.error('Error on PUT notification API', error_4);
                return [2 /*return*/, { status: MarketingNotificationResponseStatus.ERROR }];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var deactivateNotification = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, callFandomServiceWithBody("".concat(serviceNamePath, "/deactivate/").concat(id), {}, { method: 'PUT' })];
            case 1:
                response = _a.sent();
                if (response.ok) {
                    return [2 /*return*/, { status: MarketingNotificationResponseStatus.SUCCESS }];
                }
                else {
                    log.error("The notification couldn't be deactivated. Response: ".concat(response));
                    return [2 /*return*/, { status: MarketingNotificationResponseStatus.ERROR }];
                }
                return [3 /*break*/, 3];
            case 2:
                error_5 = _a.sent();
                log.error('Error on deactivate notification API', error_5);
                return [2 /*return*/, { status: MarketingNotificationResponseStatus.ERROR }];
            case 3: return [2 /*return*/];
        }
    });
}); };
var limitResults = 20;
export var getWikiCommunities = function (query) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response, results, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                url = "unified-search/community-search?query=".concat(query, "&limit=").concat(limitResults);
                return [4 /*yield*/, callFandomService(url)];
            case 1:
                response = _a.sent();
                if (!response.ok) return [3 /*break*/, 3];
                return [4 /*yield*/, response.json()];
            case 2:
                results = (_a.sent()).results;
                return [2 /*return*/, results.map(function (_a) {
                        var name = _a.name, url = _a.url, language = _a.language, id = _a.id;
                        return ({
                            id: id,
                            label: "".concat(name, " (").concat(language, ") - ").concat(url),
                            value: "".concat(name, " (").concat(language, ")"),
                        });
                    })];
            case 3:
                log.debug("Couldn't return communities. Response.status: ".concat(response.status));
                return [2 /*return*/];
            case 4: return [3 /*break*/, 6];
            case 5:
                error_6 = _a.sent();
                log.error('Error on community-search API', error_6);
                return [2 /*return*/];
            case 6: return [2 /*return*/];
        }
    });
}); };
